import { jsx as _jsx } from "react/jsx-runtime";
import { GeneralContextProvider } from './contexts/general';
import { ThemesContextProvider } from './contexts/themes';
import { ResponsesContextProvider } from './contexts/responses';
import { StimuliContextProvider } from './contexts/stimuli';
import { FiltersContextProvider } from './contexts/filters';
import { TrainingContextProvider } from './contexts/training';
import { RetrainingContextProvider } from './contexts/retraining';
import { FeedbackContextProvider } from './contexts/feedback';
import { ThemesReuseContextProvider } from './contexts/themesReuse';
import { filterValues } from './lib';
import { generalInitState, themesInitState, responsesInitState, filtersInitState, feedbackInitState, trainingInitState, retrainingInitState, stimuliInitState, themesReuseInitState } from './initState';
const Provider = ({
  values,
  children
}) => {
  return _jsx(GeneralContextProvider, {
    value: filterValues(values, generalInitState),
    children: _jsx(ThemesContextProvider, {
      value: filterValues(values, themesInitState),
      children: _jsx(ResponsesContextProvider, {
        value: filterValues(values, responsesInitState),
        children: _jsx(StimuliContextProvider, {
          value: filterValues(values, stimuliInitState),
          children: _jsx(FiltersContextProvider, {
            value: filterValues(values, filtersInitState),
            children: _jsx(FeedbackContextProvider, {
              value: filterValues(values, feedbackInitState),
              children: _jsx(TrainingContextProvider, {
                value: filterValues(values, trainingInitState),
                children: _jsx(RetrainingContextProvider, {
                  value: filterValues(values, retrainingInitState),
                  children: _jsx(ThemesReuseContextProvider, {
                    value: filterValues(values, themesReuseInitState),
                    children: children
                  })
                })
              })
            })
          })
        })
      })
    })
  });
};
export default Provider;